export const PAGE_MODULES = Object.freeze({
  ALGOLIA_CARDS: "algolia-cards",
  HERO: "heroes",
  CATEGORY_COLLECTIONS: "category-collections",
});
